"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _defaultTheme = _interopRequireDefault(require("../../../defaultTheme"));

var _onlyIE = _interopRequireDefault(require("../../../utils/onlyIE"));

var StyledButtonPrimitiveContent = (0, _styledComponents.default)(function (_ref) {
  var theme = _ref.theme,
      loading = _ref.loading,
      hasCenteredContent = _ref.hasCenteredContent,
      onlyIcon = _ref.onlyIcon,
      contentAlign = _ref.contentAlign,
      props = (0, _objectWithoutProperties2.default)(_ref, ["theme", "loading", "hasCenteredContent", "onlyIcon", "contentAlign"]);
  return /*#__PURE__*/React.createElement("div", props);
}).withConfig({
  displayName: "ButtonPrimitiveContent__StyledButtonPrimitiveContent",
  componentId: "g7vhys-0"
})(["visibility:", ";height:100%;display:flex;justify-content:", ";flex-basis:100%;align-items:center;", ";"], function (_ref2) {
  var loading = _ref2.loading;
  return loading && "hidden";
}, function (_ref3) {
  var contentAlign = _ref3.contentAlign;
  return contentAlign;
}, (0, _onlyIE.default)((0, _styledComponents.css)(["min-width:100%;max-width:1px;"]))); // $FlowFixMe: https://github.com/flow-typed/flow-typed/issues/3653#issuecomment-568539198

StyledButtonPrimitiveContent.defaultProps = {
  theme: _defaultTheme.default
};

var ButtonPrimitiveContent = function ButtonPrimitiveContent(_ref4) {
  var children = _ref4.children,
      props = (0, _objectWithoutProperties2.default)(_ref4, ["children"]);
  return /*#__PURE__*/React.createElement(StyledButtonPrimitiveContent, props, children);
};

var _default = ButtonPrimitiveContent;
exports.default = _default;